import { css } from '@emotion/react'
import Actions from 'components/App/DesktopView/shared/Composer/Header/Actions'
import Label from './Label'
import Row from './IndentedRow'
import RecipientsEditor from './RecipientsEditor'

const flexStyle = css`
  flex: 1 0 100%;
`

const BccRow = ({
  className,
  shouldShowActions,
  ccVisible,
  fromVisible,
  subjectVisible,
  onActionClick,
  ...rest
}) => {
  const { ticketId, onUpdate } = rest
  return (
    <Row css={flexStyle} className={className}>
      <Label>Bcc:</Label>
      <RecipientsEditor
        key={`recipientseditor-bcc-${ticketId}`}
        className="grui ml-3"
        type="bcc"
        onUpdateCustom={onUpdate}
        {...rest}
      />
      {shouldShowActions && (
        <div className="grui flex actions">
          <Actions
            hideBcc
            hideCc={ccVisible}
            hideFrom={fromVisible}
            hideSubject={subjectVisible}
            onClick={onActionClick}
          />
        </div>
      )}
    </Row>
  )
}

export default BccRow
